// User role constants and types
export const UserRole = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: 'ADMIN',
    AGENT: 'AGENT',
    MANAGER: 'MANAGER',
} as const;

export type UserRoleType = (typeof UserRole)[keyof typeof UserRole];

// Helper function to check if a user has a specific role
export const hasRole = (userRoles: string[], role: UserRoleType): boolean => {
    return userRoles.includes(role);
};

// Helper function to check if a user has any of the specified roles
export const hasAnyRole = (userRoles: string[], roles: UserRoleType[]): boolean => {
    return roles.some((role) => userRoles.includes(role));
};

// Helper function to get the highest role from a user's roles
export const getHighestRole = (userRoles: string[]): UserRoleType => {
    if (userRoles.includes(UserRole.SUPER_ADMIN)) {
        return UserRole.SUPER_ADMIN;
    } else if (userRoles.includes(UserRole.ADMIN)) {
        return UserRole.ADMIN;
    } else if (userRoles.includes(UserRole.MANAGER)) {
        return UserRole.MANAGER;
    } else {
        return UserRole.AGENT; // Default to AGENT
    }
};
